/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Dossiers {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags Dossiers
   * @name CreateDossier
   * @summary Create Dossier
   * @request POST:/api/dossiers
   * @secure
   */
  createDossier = (data, params = {}) =>
    this.http.request({
      path: `/api/dossiers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dossiers
   * @name ListDossiers
   * @summary List Dossiers
   * @request GET:/api/dossiers
   * @secure
   */
  listDossiers = (query, params = {}) =>
    this.http.request({
      path: `/api/dossiers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dossiers
   * @name GetDossier
   * @summary Get Dossier
   * @request GET:/api/dossiers/{id}
   * @secure
   */
  getDossier = (id, params = {}) =>
    this.http.request({
      path: `/api/dossiers/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dossiers
   * @name UpdateDossier
   * @summary Update Dossier
   * @request PATCH:/api/dossiers/{id}
   * @secure
   */
  updateDossier = (id, data, params = {}) =>
    this.http.request({
      path: `/api/dossiers/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dossiers
   * @name DeleteDossier
   * @summary Delete Dossier
   * @request DELETE:/api/dossiers/{id}
   * @secure
   */
  deleteDossier = (id, params = {}) =>
    this.http.request({
      path: `/api/dossiers/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Dossiers
   * @name TransitionDossier
   * @summary Transition Dossier
   * @request POST:/api/dossiers/{id}/transition
   * @secure
   */
  transitionDossier = (id, data, params = {}) =>
    this.http.request({
      path: `/api/dossiers/${id}/transition`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dossiers
   * @name HandoffToApplication
   * @summary Handoff To Application
   * @request POST:/api/dossiers/{id}/handoff-application
   * @secure
   */
  handoffToApplication = (id, data, params = {}) =>
    this.http.request({
      path: `/api/dossiers/${id}/handoff-application`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dossiers
   * @name HandoffToRental
   * @summary Handoff To Rental
   * @request POST:/api/dossiers/{id}/handoff-rental
   * @secure
   */
  handoffToRental = (id, data, params = {}) =>
    this.http.request({
      path: `/api/dossiers/${id}/handoff-rental`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
